export default __webpack_public_path__ + "static/media/NW.d945ee26.jpg";